import React from 'react'
import {  useNavigate } from 'react-router-dom'
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function FeaturedpropertyList({settings,FeturedProperties}) {

    const navigate = useNavigate()

  const redirectToPropertyDetails = (id) => {
    navigate(`/viewPropertyDetails/${id}`)
  }

  return (
    <>
 
            <Slider {...settings}>
              {FeturedProperties?.map((data) => (
                <div class="box px-0">
                  <div class="card border-0">
                    <img
                      src={data.mediaData.images[0]}
                      class="card-img w-400 h-244"
                      alt="Villa on Hollywood Boulevard"
                      style={{ width: "400px", height: "244px" }}
                    />
                    <div
                      class="card-img-overlay d-flex flex-column bg-gradient-3 rounded-lg">
                      <div class="d-flex mb-auto">
                        {data.propertydata?.promotePropertyStatus ? <a href="#" class="mr-1 badge badge-orange">featured</a> : null}
                        {
                          data.propertydata?.listedin == "rent" ?
                            <a href="#" class="badge badge-indigo">for Rent</a>
                            :
                            <a href="#" class="badge badge-indigo">for Sell</a>
                        }
                      </div>
                      <div class="px-2 pb-2">
                        <a onClick={() => redirectToPropertyDetails(data.propertydata.id)} class="text-white">
                          <h5 class="card-title fs-16 lh-2 mb-0">{data.propertydata.title}</h5>
                        </a>
                        <p class="card-text text-gray-light mb-0 font-weight-500">{data.locationData.address}{" "}{data.locationData.city}{" "}{data.locationData.state}{" "}</p>
                        <p class="text-white mb-0"><span
                          class="fs-17 font-weight-bold">{data.propertydata.price?.toLocaleString("en-IN")}</span>{data.propertydata?.listedin == "rent" ? "/month" : null}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </Slider>
      
    
    </>
  )
}

export default FeaturedpropertyList